export enum VisitStatus {
    NORMAL = 'Normal',
    COMPLETED_VISIT = 'Completed Visit',
    NO_COMPLETED_VISIT = 'No Completed Visit',
    NO_SHOW = 'No Show',
}
